import { useFormContext } from 'react-hook-form';

import type { ExamCenterLocationRequestVerdictFormType } from './schema';

export const useExamCenterLocationRequestVerdictFormContext =
  useFormContext<ExamCenterLocationRequestVerdictFormType>;
